import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";
// import JobDataIcon from '@mui/icons-material/TableChart';

const jobPanelCountsRoute: RouteType = {
  name: "Piece Count",
  path: "/piece-count",
  layout: "/app",
  hidden: true,
  viewportCard: {
    header: {
      title: "Piece Count",
      // If there's no separate header component, you might reuse the main component or create a placeholder
      // component: () => import('./JobData.Header'),  // Uncomment and replace if a dedicated header exists
      // component: () => import('./JobPanelCounts.Header'), // Or reuse the main component if no separate header
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      // component: () => import('./JobPanelCounts.Body'),
      // grayBackground:  Add if needed based on the old implementation styling.
      gridContainer: {
        namespace: "JobPanelCountsDataGrid",
        storeName: "jobPanelCountsStore",
        // customEntity: 'qrCodeRows',
        // fixedRowCount: 2,
        columnHeaders: [
          {
            width: 100,
            title: "Client Id",
            key: "jobNumber",
            dataType: "number",
          },
          {
            width: 300,
            title: "Client Name",
            key: "jobName",
          },
          {
            width: 160,
            title: "Types",
            key: "productType",
          },
          {
            width: 160,
            title: "Total Sq Ft",
            key: "totalSqFt",
            dataType: "number",
          },
          {
            width: 140,
            title: "Total Pieces",
            key: "totalCount",
            dataType: "number",
          },
          {
            width: 140,
            title: "Main Pieces",
            key: "panelCount",
            dataType: "number",
          },
          {
            width: 140,
            title: "Assem. Pieces",
            key: "assemblyCount",
            dataType: "number",
          },
          {
            width: 120,
            title: "Series Count",
            key: "markCount",
            dataType: "number",
          },
          {
            width: 140,
            title: "Series/Piece Ratio",
            key: "markToPanelRatio",
            dataType: "number",
          },
        ],
        // customEntity: 'jobDataList',
        defaultSort: {
          sortBy: ["jobNumber"],
          sortDirection: { jobNumber: "ASC" },
        },
        onRowClick: () => console.log("Clicked"),
        // onRowClick: ({ controlUUID }) =>
        // openDialog({
        //   dialogName: 'QR Code',
        //   dialogContext: controlUUID
        // })
      },
    },
  },
  group: "Project Management",
  requiresAuth: true, // Assumed true since requiresPermission is true
  requiresPermission: false,
  channels: ["job"],
  enableAutoFind: false,
  onEnter: async ({ rootStore }) => {
    const jobStore = rootStore.jobStore as ServiceStore;
    const jobStatsPanelCountStore =
      rootStore.jobStatsPanelCountStore as ServiceStore;

    jobStore.find();
    jobStatsPanelCountStore.find();
  },
  // Add icon to the new format if needed.  It's not part of the core RouteType but can be added as a custom property.
  // icon: JobDataIcon, //  Example. Adjust based on how you use the icon in the new format.
  // Handle other properties (noSection, sideBarShortcut, homeShortcut, hidden) as needed in the new structure. These are not directly part of RouteType but could be added if necessary.
  //  Example:
  // customProperties: {
  //
  //
  //
  //   hidden: false,
  // },
};

export default jobPanelCountsRoute;
